import { create } from "zustand";
import axiosInstance from "../../api/axiosInstance";

interface Field {
  type: string;
  value: string;
  link?: string;
}

interface Testimonial {
  title: string;
  description: string;
  image: string;
}

interface Section {
  id: number;
  section_name: string;
  payload: Record<string, Field>;
  loop_fields: Testimonial[];
  loaded?: boolean;
}

interface HomeState {
  sections: Record<string, Section>;
  fetchSectionsList: () => Promise<void>;
}

const useHomeStore = create<HomeState>((set) => ({
  sections: {},

  // Fetch every section for this page, with full content, in a single request.
  fetchSectionsList: async () => {
    try {
      const response = await axiosInstance.get("/cmsPages/home");
      const sectionsList = response.data.pages.rows;

      const formattedSections = sectionsList.reduce(
        (acc: Record<string, Section>, section: any) => {
          acc[section.section_name] = {
            id: section.id,
            section_name: section.section_name,
            payload: JSON.parse(section.payload || "{}"),
            loop_fields: JSON.parse(section.loop_fields || "[]"),
            loaded: true,
          };
          return acc;
        },
        {}
      );
      set({ sections: formattedSections });
    } catch (error) {
      console.error("Error fetching sections list:", error);
    }
  },
}));

export default useHomeStore;
